export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_EPISODES':
            return Object.assign({},state,{ui: action.payload.ui})
        case 'GET_EPISODES_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        case 'GET_EPISODES_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                podcast: action.payload.podcast
            })
        default:
            return state
    }
}
